export const WORD_CLOUD_PALETTE_IDS = ['classic', 'ocean', 'sunset', 'forest', 'light'] as const;

export type WordCloudPaletteId = typeof WORD_CLOUD_PALETTE_IDS[number];

export const DEFAULT_WORD_CLOUD_PALETTE: WordCloudPaletteId = 'classic';

export const WORD_CLOUD_PALETTES: Record<WordCloudPaletteId, readonly string[]> = {
    classic: ['#1B7A35', '#66E0E5', '#2563EB', '#A9CFFF', '#6B7280', '#F5D85A', '#A94800', '#FFD0B8', '#B91C1C', '#FFB0D0'],
    ocean: ['#0F172A', '#2563EB', '#06B6D4', '#059669', '#7C3AED', '#38BDF8'],
    sunset: ['#7F1D1D', '#DC2626', '#EA580C', '#D97706', '#DB2777', '#FBBF24'],
    forest: ['#052E16', '#16A34A', '#84CC16', '#0E7490', '#CA8A04', '#047857'],
    light: ['#7DD3FC', '#FDE047', '#F9A8D4', '#86EFAC', '#C4B5FD', '#FDBA74'],
};

export function wordCloudPaletteColors(palette?: string): readonly string[] {
    if (palette && palette in WORD_CLOUD_PALETTES) {
        return WORD_CLOUD_PALETTES[palette as WordCloudPaletteId];
    }
    return WORD_CLOUD_PALETTES[DEFAULT_WORD_CLOUD_PALETTE];
}
